import { getQuery } from 'utilities/query';

export default class MapCategoriesService {
  constructor($http) {
    'ngInject';

    this.$http = $http;
  }

  getProductQuery() {
    return {
      ...getQuery(),
      orderBy: 'ProductName',
      direction: 'asc'
    };
  }

  searchProducts(query) {
    return this.$http.get('/odata/ProductCategoryMappingOData', {
      params: {
        $select: 'ProductId, ProductCategoryId, ProductName, MapCount',
        $top: query.take,
        $skip: query.calculateSkip(),
        $orderby: `${query.orderBy} ${query.direction}`,
        ...query.filter && { $filter: query.filter.toString() },
        $count: true
      }
    });
  }

  addProductCategoryMapping(productCategoryId, productIds) {
    return this.$http.post(`/api/product_category/${productCategoryId}/products`, {
      productCategoryId,
      productIds
    });
  }

  removeProductCategoryMapping(productCategoryId, productIds) {
    return this.$http.delete(`/api/product_category/${productCategoryId}/products`, {
      data: {
        productCategoryId,
        productIds
      }
    });
  }
}



// WEBPACK FOOTER //
// ./components/app/admin/map-categories/map-categories.service.js